import { Group } from "konva/lib/Core";
import { ISelectable, addSelectedGetterSetter } from "../behaviors/selection";
import { IWhiteboardShapeState, IPosition } from ".";
import { draggable } from "../behaviors/draggable";
import { IWhiteboardRendererContext, IWhiteboardRenderOptions } from "../whiteboard-renderer";

export interface IShape<State extends IWhiteboardShapeState> {
  state: State;
  updateState(state: State): boolean;
}

export interface IShapeState {
  id: string;
  bsonId?: string;
  position: IPosition;
  createdById: string;
  zIndex?: number;
  rotationAngle?: number;
}

export const reservedImportedShapeFields: (keyof IWhiteboardShapeState)[] = ["id", "type", "position", "createdById", "zIndex"];

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-interface
export interface WhiteboardShape<State extends IWhiteboardShapeState = IWhiteboardShapeState> extends ISelectable {}
export abstract class WhiteboardShape<State extends IWhiteboardShapeState = IWhiteboardShapeState> extends Group implements IShape<State> {
  constructor(public state: State, protected context: IWhiteboardRendererContext) {
    super(Object.assign({}, state.position));

    draggable(this);
  }

  abstract updateState(state: State, options?: IWhiteboardRenderOptions): boolean;
}

addSelectedGetterSetter(WhiteboardShape as any);
